export const DEVTOOLS_EVENT = 'react-devtools-bridge';
